var map = {
	"./AD.png": "4f01",
	"./AE.png": "ea19",
	"./AG.png": "d158",
	"./AM.png": "be2c",
	"./AR.png": "9607",
	"./AT.png": "5041",
	"./AU.png": "dcef",
	"./BE.png": "6b7fd",
	"./BF.png": "2e64",
	"./BG.png": "3ba8",
	"./BO.png": "f587",
	"./BR.png": "7683",
	"./CA.png": "856b",
	"./CAD.png": "d166",
	"./CD.png": "f1f5",
	"./CG.png": "b2b0",
	"./CH.png": "65f1",
	"./CL.png": "c65a",
	"./CM.png": "a814",
	"./CN.png": "5064",
	"./CO.png": "8d30",
	"./CZ.png": "241e",
	"./DE.png": "4749",
	"./DJ.png": "4139",
	"./DK.png": "887b",
	"./DZ.png": "2fd4",
	"./EE.png": "991d",
	"./EG.png": "3738",
	"./ES.png": "e7db",
	"./FI.png": "aa8c",
	"./FR.png": "773c",
	"./GA.png": "9cc8",
	"./GB.png": "ae65",
	"./GM.png": "a4a6",
	"./GT.png": "90ac",
	"./HN.png": "ca8e",
	"./HT.png": "a849",
	"./HU.png": "a0d2",
	"./ID.png": "ba3a",
	"./IE.png": "dcd1",
	"./IL.png": "9fe7",
	"./IN.png": "4c66",
	"./IQ.png": "78fa",
	"./IR.png": "c100",
	"./IT.png": "37bf",
	"./JM.png": "7da9",
	"./JO.png": "119b",
	"./JP.png": "dceb",
	"./KG.png": "6c65",
	"./KN.png": "5c09",
	"./KP.png": "103c",
	"./KR.png": "27e5",
	"./KW.png": "53b6",
	"./KZ.png": "10cf",
	"./LA.png": "1013",
	"./LB.png": "4128",
	"./LC.png": "f1f7",
	"./LS.png": "89e5",
	"./LU.png": "5d6c",
	"./LV.png": "70db",
	"./MG.png": "0f83",
	"./MK.png": "70b5",
	"./ML.png": "ba4a",
	"./MM.png": "3892",
	"./MT.png": "0668",
	"./MX.png": "6eb9",
	"./NA.png": "0b5c",
	"./NE.png": "586b",
	"./NG.png": "420e",
	"./NI.png": "2aeb",
	"./NL.png": "8cb7",
	"./NO.png": "890a",
	"./OM.png": "8b12",
	"./PA.png": "dd61",
	"./PE.png": "9cc89",
	"./PG.png": "66b8",
	"./PK.png": "87d5",
	"./PL.png": "33d0",
	"./PT.png": "615f",
	"./PY.png": "d619",
	"./QA.png": "0fcd",
	"./RO.png": "daa7",
	"./RU.png": "fb02",
	"./RW.png": "dea8",
	"./SA.png": "2665",
	"./SE.png": "8693",
	"./SG.png": "9ec4",
	"./SL.png": "dccd",
	"./SN.png": "c5af",
	"./SO.png": "9a33",
	"./SV.png": "2b8e",
	"./TD.png": "d059",
	"./TJ.png": "22ac",
	"./TL.png": "d84d",
	"./TR.png": "1ea5",
	"./TZ.png": "2ae0",
	"./UA.png": "7885",
	"./US.png": "7770",
	"./USD.png": "b77b",
	"./VE.png": "11ad",
	"./VN.png": "d842",
	"./YE.png": "9c55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";